/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * CyrenCare API
 * CyrenCare NestJS REST API for healthcare survey platform
 * OpenAPI spec version: 2.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ArchivedDataDeletionDto,
  Config,
  ConfigControllerGetArchivedDataDeletion200,
  ConfigControllerGetDataRetention200,
  ConfigControllerGetTranslationSupportLanguages200,
  CreateConfigDto,
  DataRetentionDto,
  UpdateConfigDto,
  UpdateDefaultLanguageDto,
  UpdateTranslationSupportLanguagesDto
} from '.././types'
import { customInstance } from '../../custom-instance';
import type { ErrorType } from '../../custom-instance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Get translation support languages for organization
 */
export const configControllerGetTranslationSupportLanguages = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ConfigControllerGetTranslationSupportLanguages200>(
      {url: `/config/translation-support-languages`, method: 'GET', signal
    },
      options);
    }
  

export const getConfigControllerGetTranslationSupportLanguagesQueryKey = () => {
    return [`/config/translation-support-languages`] as const;
    }

    
export const getConfigControllerGetTranslationSupportLanguagesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof configControllerGetTranslationSupportLanguages>>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof configControllerGetTranslationSupportLanguages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConfigControllerGetTranslationSupportLanguagesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof configControllerGetTranslationSupportLanguages>>> = ({ signal }) => configControllerGetTranslationSupportLanguages(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof configControllerGetTranslationSupportLanguages>>, TError, TData> & { queryKey: QueryKey }
}

export type ConfigControllerGetTranslationSupportLanguagesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof configControllerGetTranslationSupportLanguages>>>
export type ConfigControllerGetTranslationSupportLanguagesInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Get translation support languages for organization
 */
export const useConfigControllerGetTranslationSupportLanguagesInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof configControllerGetTranslationSupportLanguages>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof configControllerGetTranslationSupportLanguages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConfigControllerGetTranslationSupportLanguagesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getConfigControllerGetTranslationSupportLanguagesQueryOptions = <TData = Awaited<ReturnType<typeof configControllerGetTranslationSupportLanguages>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof configControllerGetTranslationSupportLanguages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConfigControllerGetTranslationSupportLanguagesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof configControllerGetTranslationSupportLanguages>>> = ({ signal }) => configControllerGetTranslationSupportLanguages(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof configControllerGetTranslationSupportLanguages>>, TError, TData> & { queryKey: QueryKey }
}

export type ConfigControllerGetTranslationSupportLanguagesQueryResult = NonNullable<Awaited<ReturnType<typeof configControllerGetTranslationSupportLanguages>>>
export type ConfigControllerGetTranslationSupportLanguagesQueryError = ErrorType<unknown>

/**
 * @summary Get translation support languages for organization
 */
export const useConfigControllerGetTranslationSupportLanguages = <TData = Awaited<ReturnType<typeof configControllerGetTranslationSupportLanguages>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof configControllerGetTranslationSupportLanguages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConfigControllerGetTranslationSupportLanguagesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update translation support languages for organization
 */
export const configControllerUpdateTranslationSupportLanguages = (
    updateTranslationSupportLanguagesDto: UpdateTranslationSupportLanguagesDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/config/translation-support-languages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateTranslationSupportLanguagesDto
    },
      options);
    }
  


export const getConfigControllerUpdateTranslationSupportLanguagesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof configControllerUpdateTranslationSupportLanguages>>, TError,{data: UpdateTranslationSupportLanguagesDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof configControllerUpdateTranslationSupportLanguages>>, TError,{data: UpdateTranslationSupportLanguagesDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof configControllerUpdateTranslationSupportLanguages>>, {data: UpdateTranslationSupportLanguagesDto}> = (props) => {
          const {data} = props ?? {};

          return  configControllerUpdateTranslationSupportLanguages(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfigControllerUpdateTranslationSupportLanguagesMutationResult = NonNullable<Awaited<ReturnType<typeof configControllerUpdateTranslationSupportLanguages>>>
    export type ConfigControllerUpdateTranslationSupportLanguagesMutationBody = UpdateTranslationSupportLanguagesDto
    export type ConfigControllerUpdateTranslationSupportLanguagesMutationError = ErrorType<unknown>

    /**
 * @summary Update translation support languages for organization
 */
export const useConfigControllerUpdateTranslationSupportLanguages = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof configControllerUpdateTranslationSupportLanguages>>, TError,{data: UpdateTranslationSupportLanguagesDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof configControllerUpdateTranslationSupportLanguages>>,
        TError,
        {data: UpdateTranslationSupportLanguagesDto},
        TContext
      > => {

      const mutationOptions = getConfigControllerUpdateTranslationSupportLanguagesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get data retention configuration for organization
 */
export const configControllerGetDataRetention = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ConfigControllerGetDataRetention200>(
      {url: `/config/data-retention`, method: 'GET', signal
    },
      options);
    }
  

export const getConfigControllerGetDataRetentionQueryKey = () => {
    return [`/config/data-retention`] as const;
    }

    
export const getConfigControllerGetDataRetentionInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof configControllerGetDataRetention>>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof configControllerGetDataRetention>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConfigControllerGetDataRetentionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof configControllerGetDataRetention>>> = ({ signal }) => configControllerGetDataRetention(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof configControllerGetDataRetention>>, TError, TData> & { queryKey: QueryKey }
}

export type ConfigControllerGetDataRetentionInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof configControllerGetDataRetention>>>
export type ConfigControllerGetDataRetentionInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Get data retention configuration for organization
 */
export const useConfigControllerGetDataRetentionInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof configControllerGetDataRetention>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof configControllerGetDataRetention>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConfigControllerGetDataRetentionInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getConfigControllerGetDataRetentionQueryOptions = <TData = Awaited<ReturnType<typeof configControllerGetDataRetention>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof configControllerGetDataRetention>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConfigControllerGetDataRetentionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof configControllerGetDataRetention>>> = ({ signal }) => configControllerGetDataRetention(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof configControllerGetDataRetention>>, TError, TData> & { queryKey: QueryKey }
}

export type ConfigControllerGetDataRetentionQueryResult = NonNullable<Awaited<ReturnType<typeof configControllerGetDataRetention>>>
export type ConfigControllerGetDataRetentionQueryError = ErrorType<unknown>

/**
 * @summary Get data retention configuration for organization
 */
export const useConfigControllerGetDataRetention = <TData = Awaited<ReturnType<typeof configControllerGetDataRetention>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof configControllerGetDataRetention>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConfigControllerGetDataRetentionQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update data retention configuration for organization
 */
export const configControllerUpdateDataRetention = (
    dataRetentionDto: DataRetentionDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/config/data-retention`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dataRetentionDto
    },
      options);
    }
  


export const getConfigControllerUpdateDataRetentionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof configControllerUpdateDataRetention>>, TError,{data: DataRetentionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof configControllerUpdateDataRetention>>, TError,{data: DataRetentionDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof configControllerUpdateDataRetention>>, {data: DataRetentionDto}> = (props) => {
          const {data} = props ?? {};

          return  configControllerUpdateDataRetention(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfigControllerUpdateDataRetentionMutationResult = NonNullable<Awaited<ReturnType<typeof configControllerUpdateDataRetention>>>
    export type ConfigControllerUpdateDataRetentionMutationBody = DataRetentionDto
    export type ConfigControllerUpdateDataRetentionMutationError = ErrorType<unknown>

    /**
 * @summary Update data retention configuration for organization
 */
export const useConfigControllerUpdateDataRetention = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof configControllerUpdateDataRetention>>, TError,{data: DataRetentionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof configControllerUpdateDataRetention>>,
        TError,
        {data: DataRetentionDto},
        TContext
      > => {

      const mutationOptions = getConfigControllerUpdateDataRetentionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get archived data deletion configuration for organization
 */
export const configControllerGetArchivedDataDeletion = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ConfigControllerGetArchivedDataDeletion200>(
      {url: `/config/archived-data-deletion`, method: 'GET', signal
    },
      options);
    }
  

export const getConfigControllerGetArchivedDataDeletionQueryKey = () => {
    return [`/config/archived-data-deletion`] as const;
    }

    
export const getConfigControllerGetArchivedDataDeletionInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof configControllerGetArchivedDataDeletion>>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof configControllerGetArchivedDataDeletion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConfigControllerGetArchivedDataDeletionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof configControllerGetArchivedDataDeletion>>> = ({ signal }) => configControllerGetArchivedDataDeletion(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof configControllerGetArchivedDataDeletion>>, TError, TData> & { queryKey: QueryKey }
}

export type ConfigControllerGetArchivedDataDeletionInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof configControllerGetArchivedDataDeletion>>>
export type ConfigControllerGetArchivedDataDeletionInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Get archived data deletion configuration for organization
 */
export const useConfigControllerGetArchivedDataDeletionInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof configControllerGetArchivedDataDeletion>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof configControllerGetArchivedDataDeletion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConfigControllerGetArchivedDataDeletionInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getConfigControllerGetArchivedDataDeletionQueryOptions = <TData = Awaited<ReturnType<typeof configControllerGetArchivedDataDeletion>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof configControllerGetArchivedDataDeletion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConfigControllerGetArchivedDataDeletionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof configControllerGetArchivedDataDeletion>>> = ({ signal }) => configControllerGetArchivedDataDeletion(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof configControllerGetArchivedDataDeletion>>, TError, TData> & { queryKey: QueryKey }
}

export type ConfigControllerGetArchivedDataDeletionQueryResult = NonNullable<Awaited<ReturnType<typeof configControllerGetArchivedDataDeletion>>>
export type ConfigControllerGetArchivedDataDeletionQueryError = ErrorType<unknown>

/**
 * @summary Get archived data deletion configuration for organization
 */
export const useConfigControllerGetArchivedDataDeletion = <TData = Awaited<ReturnType<typeof configControllerGetArchivedDataDeletion>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof configControllerGetArchivedDataDeletion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConfigControllerGetArchivedDataDeletionQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update archived data deletion configuration for organization
 */
export const configControllerUpdateArchivedDataDeletion = (
    archivedDataDeletionDto: ArchivedDataDeletionDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/config/archived-data-deletion`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: archivedDataDeletionDto
    },
      options);
    }
  


export const getConfigControllerUpdateArchivedDataDeletionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof configControllerUpdateArchivedDataDeletion>>, TError,{data: ArchivedDataDeletionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof configControllerUpdateArchivedDataDeletion>>, TError,{data: ArchivedDataDeletionDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof configControllerUpdateArchivedDataDeletion>>, {data: ArchivedDataDeletionDto}> = (props) => {
          const {data} = props ?? {};

          return  configControllerUpdateArchivedDataDeletion(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfigControllerUpdateArchivedDataDeletionMutationResult = NonNullable<Awaited<ReturnType<typeof configControllerUpdateArchivedDataDeletion>>>
    export type ConfigControllerUpdateArchivedDataDeletionMutationBody = ArchivedDataDeletionDto
    export type ConfigControllerUpdateArchivedDataDeletionMutationError = ErrorType<unknown>

    /**
 * @summary Update archived data deletion configuration for organization
 */
export const useConfigControllerUpdateArchivedDataDeletion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof configControllerUpdateArchivedDataDeletion>>, TError,{data: ArchivedDataDeletionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof configControllerUpdateArchivedDataDeletion>>,
        TError,
        {data: ArchivedDataDeletionDto},
        TContext
      > => {

      const mutationOptions = getConfigControllerUpdateArchivedDataDeletionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const configControllerCreate = (
    createConfigDto: CreateConfigDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/config`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createConfigDto
    },
      options);
    }
  


export const getConfigControllerCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof configControllerCreate>>, TError,{data: CreateConfigDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof configControllerCreate>>, TError,{data: CreateConfigDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof configControllerCreate>>, {data: CreateConfigDto}> = (props) => {
          const {data} = props ?? {};

          return  configControllerCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfigControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof configControllerCreate>>>
    export type ConfigControllerCreateMutationBody = CreateConfigDto
    export type ConfigControllerCreateMutationError = ErrorType<unknown>

    export const useConfigControllerCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof configControllerCreate>>, TError,{data: CreateConfigDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof configControllerCreate>>,
        TError,
        {data: CreateConfigDto},
        TContext
      > => {

      const mutationOptions = getConfigControllerCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get all configs
 */
export const configControllerFindAll = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Config[]>(
      {url: `/config`, method: 'GET', signal
    },
      options);
    }
  

export const getConfigControllerFindAllQueryKey = () => {
    return [`/config`] as const;
    }

    
export const getConfigControllerFindAllInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof configControllerFindAll>>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof configControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConfigControllerFindAllQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof configControllerFindAll>>> = ({ signal }) => configControllerFindAll(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof configControllerFindAll>>, TError, TData> & { queryKey: QueryKey }
}

export type ConfigControllerFindAllInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof configControllerFindAll>>>
export type ConfigControllerFindAllInfiniteQueryError = ErrorType<unknown>

export const useConfigControllerFindAllInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof configControllerFindAll>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof configControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConfigControllerFindAllInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getConfigControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof configControllerFindAll>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof configControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConfigControllerFindAllQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof configControllerFindAll>>> = ({ signal }) => configControllerFindAll(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof configControllerFindAll>>, TError, TData> & { queryKey: QueryKey }
}

export type ConfigControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof configControllerFindAll>>>
export type ConfigControllerFindAllQueryError = ErrorType<unknown>

export const useConfigControllerFindAll = <TData = Awaited<ReturnType<typeof configControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof configControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConfigControllerFindAllQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const configControllerFindOne = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/config/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getConfigControllerFindOneQueryKey = (id: string,) => {
    return [`/config/${id}`] as const;
    }

    
export const getConfigControllerFindOneInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof configControllerFindOne>>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof configControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConfigControllerFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof configControllerFindOne>>> = ({ signal }) => configControllerFindOne(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof configControllerFindOne>>, TError, TData> & { queryKey: QueryKey }
}

export type ConfigControllerFindOneInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof configControllerFindOne>>>
export type ConfigControllerFindOneInfiniteQueryError = ErrorType<unknown>

export const useConfigControllerFindOneInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof configControllerFindOne>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof configControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConfigControllerFindOneInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getConfigControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof configControllerFindOne>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof configControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getConfigControllerFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof configControllerFindOne>>> = ({ signal }) => configControllerFindOne(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof configControllerFindOne>>, TError, TData> & { queryKey: QueryKey }
}

export type ConfigControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof configControllerFindOne>>>
export type ConfigControllerFindOneQueryError = ErrorType<unknown>

export const useConfigControllerFindOne = <TData = Awaited<ReturnType<typeof configControllerFindOne>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof configControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getConfigControllerFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const configControllerUpdate = (
    id: string,
    updateConfigDto: UpdateConfigDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/config/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateConfigDto
    },
      options);
    }
  


export const getConfigControllerUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof configControllerUpdate>>, TError,{id: string;data: UpdateConfigDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof configControllerUpdate>>, TError,{id: string;data: UpdateConfigDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof configControllerUpdate>>, {id: string;data: UpdateConfigDto}> = (props) => {
          const {id,data} = props ?? {};

          return  configControllerUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfigControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof configControllerUpdate>>>
    export type ConfigControllerUpdateMutationBody = UpdateConfigDto
    export type ConfigControllerUpdateMutationError = ErrorType<unknown>

    export const useConfigControllerUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof configControllerUpdate>>, TError,{id: string;data: UpdateConfigDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof configControllerUpdate>>,
        TError,
        {id: string;data: UpdateConfigDto},
        TContext
      > => {

      const mutationOptions = getConfigControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const configControllerRemove = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/config/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getConfigControllerRemoveMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof configControllerRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof configControllerRemove>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof configControllerRemove>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  configControllerRemove(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfigControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof configControllerRemove>>>
    
    export type ConfigControllerRemoveMutationError = ErrorType<unknown>

    export const useConfigControllerRemove = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof configControllerRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof configControllerRemove>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getConfigControllerRemoveMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Update default language for an organization
 */
export const configControllerUpdateDefaultLanguage = (
    organizationId: string,
    updateDefaultLanguageDto: UpdateDefaultLanguageDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/config/${organizationId}/default_language`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateDefaultLanguageDto
    },
      options);
    }
  


export const getConfigControllerUpdateDefaultLanguageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof configControllerUpdateDefaultLanguage>>, TError,{organizationId: string;data: UpdateDefaultLanguageDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof configControllerUpdateDefaultLanguage>>, TError,{organizationId: string;data: UpdateDefaultLanguageDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof configControllerUpdateDefaultLanguage>>, {organizationId: string;data: UpdateDefaultLanguageDto}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  configControllerUpdateDefaultLanguage(organizationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ConfigControllerUpdateDefaultLanguageMutationResult = NonNullable<Awaited<ReturnType<typeof configControllerUpdateDefaultLanguage>>>
    export type ConfigControllerUpdateDefaultLanguageMutationBody = UpdateDefaultLanguageDto
    export type ConfigControllerUpdateDefaultLanguageMutationError = ErrorType<void>

    /**
 * @summary Update default language for an organization
 */
export const useConfigControllerUpdateDefaultLanguage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof configControllerUpdateDefaultLanguage>>, TError,{organizationId: string;data: UpdateDefaultLanguageDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof configControllerUpdateDefaultLanguage>>,
        TError,
        {organizationId: string;data: UpdateDefaultLanguageDto},
        TContext
      > => {

      const mutationOptions = getConfigControllerUpdateDefaultLanguageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    